<template>
  <div id="_empty-view"></div>
</template>

<script>
export default{
  data () {
    return {
      target: this.$route.query.target ? this.$route.query.target : null,
      inviteCode: this.$route.query.inviteCode ? this.$route.query.inviteCode : null,
      from: this.$route.query.from ? this.$route.query.from : null,
      pcTarget: this.$route.query.pcTarget ? this.$route.query.pcTarget : null
    }
  },
  mounted () {
    if (this.target === 'wxShare') {
      window.href = 'http://www.puhuilicai.com:7000/weixin/content/perShare?inviteCode=' + this.inviteCode + '&from=' + this.this.inviteCode
    } else if (this.pcTarget) {
      if (this.pcTarget.indexOf('news') !== -1) {
        this.$router.replace({
          path: this.pcTarget
        })
      } else {
        this.$router.replace({
          name: this.pcTarget
        })
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/common/_empty.vue